import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import DashboardLayout from "../../components/SharedLayouts/DashboardLayout";
import CustomButton from "../../components/Buttons/Button";
import StocksTable from "../../components/dashboard/stocks/StocksTable";
import OrdersTable from "../../components/dashboard/stocks/OrdersTable";
import BulkUploadStockModal from "../../components/modal/BulkUploadStockModal";
import { getStocks } from "../../store/actions/stocks/getStocks";
import { getStockOrders } from "../../store/actions/stocks/getStockOrders";

const tabs = [
  { id: "stocks", name: "Stocks" },
  { id: "orders", name: "Orders" },
];

function Stocks() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("stocks");
  const [bulkUploadOpen, setBulkUploadOpen] = useState(false);

  useEffect(() => {
    dispatch(getStocks());
    dispatch(getStockOrders({ side: "buy" }));
    dispatch(getStockOrders({ side: "sell" }));
  }, [dispatch]);

  return (
    <DashboardLayout>
      <div className="px-4 md:px-8">
        <div className="flex items-center mb-4 md:flex-row md:items-center w-full">
          <Link to={"/dashboard"}>
            <img src="/Assets/bread.png" alt="" className="w-8 h-8 mr-1" />
          </Link>
          <img src="/Assets/chev.png" alt="" className="w-8 h-8 mr-1" />
          <div className="font-semibold text-[#475467] text-sm sm:text-base bg-[#F9FAFB] p-1 px-3 rounded-md">
            Stocks Management
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center border-b border-b-[#EAECF0] md:items-center mb-6">
          <div></div>
          <div className="flex flex-col md:flex-row items-center gap-0 md:gap-3">
            <CustomButton
              variant="outlined"
              customColor="#fff"
              children="Bulk Upload Stocks"
              width="220px"
              height="45px"
              padding="10px"
              margin="15px 0"
              borderColor="#159AA8"
              color="#159AA8"
              onClick={() => setBulkUploadOpen(true)}
            />
            <CustomButton
              variant="contained"
              customColor="#159AA8"
              children="Create a New Stock"
              width="220px"
              height="45px"
              padding="10px"
              margin="15px 0"
              color="#fff"
              onClick={() => navigate("/stocks/create")}
            />
          </div>
        </div>

        <div className="mb-8 cursor-pointer w-full overflow-x-auto">
          <div className="w-[max-content] flex items-center">
            {tabs.map((tab) => (
              <span
                key={tab.id}
                className={`${
                  activeTab === tab.id
                    ? "border-b-2 border-[#128591] text-[#128591] font-[600]"
                    : "text-gray-700"
                } mr-6 text-base pb-2`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.name}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-4">
          {activeTab === "stocks" ? <StocksTable /> : <OrdersTable />}
        </div>
      </div>

      <BulkUploadStockModal
        open={bulkUploadOpen}
        onClose={() => setBulkUploadOpen(false)}
        onSuccess={() => dispatch(getStocks())}
      />
    </DashboardLayout>
  );
}

export default Stocks;
